import { ICombinedUserData } from 'lib/context';

// Vin Reels
export const checkIfVinReelsAvailable = (userData: ICombinedUserData) => {
  return !!Number(userData?.customer?.isUsingVinReels);
};
// AI Spotlight
export const checkIfAISpotlightAvailable = (userData: ICombinedUserData) => {
  return (
    !!Number(userData?.customer?.spotlightEnabled) &&
    !!Number(userData?.spotlightEnabled)
  );
};
export const checkIfAISpotlightAvailableForCustomer = (
  userData: ICombinedUserData
) => {
  return !!Number(userData?.customer?.spotlightEnabled);
};
// Quick Videos
export const checkIfQuickVideosAvailable = (userData: ICombinedUserData) => {
  return !!Number(userData?.customer?.quickVideosEnabled);
};
// Suggested Content
export const checkIfSuggestedContentAvailable = (
  userData: ICombinedUserData
) => {
  return !!Number(userData?.customer?.suggestedContentEnabled);
};
// AI Assistant
export const checkIfAIAssistantAvailable = (userData: ICombinedUserData) => {
  return (
    !!Number(userData?.customer?.quickVideoAvatarEnabled) &&
    !!Number(userData?.quickVideoAvatarEnabled)
  );
};
export const checkIfAIAssistantAvailableForCustomer = (
  userData: ICombinedUserData
) => {
  return !!Number(userData?.customer?.quickVideoAvatarEnabled);
};
// AI Music
export const checkIfAIMusicAvailable = (userData: ICombinedUserData) => {
  return !!Number(userData?.customer?.aiMusicEnabled);
};
// AI Scripts
export const checkIfAIScriptsAvailable = (userData: ICombinedUserData) => {
  return !!Number(userData?.customer?.hasCovideoMagic);
};
